"use client"

import { useSearchParams } from "react-router-dom"

/**
 * Read-only search params, backed by React Router (works on web and Capacitor).
 * Kept as a single import path for pages that used the Next-safe wrapper.
 */
export function useSearchParamsSafe() {
  const [searchParams] = useSearchParams()
  return searchParams
}
